// TODO: If your Module name is updated, this will need to be updated to reflect
const API_MODULE_NAME = 'estiabilt';

class ApiError extends Error {

}

export class Api {
    static apiFetch(method, endpoint, body = null, additionalHeaders = {}) {
        const url = `/actions/${API_MODULE_NAME}/${endpoint}`;

        const fetchParams = {
            method: method,
            body: body,
            credentials: 'include',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'HTTP_X_REQUESTED_WITH': 'XMLHttpRequest',
                ...additionalHeaders,
            },
        };

        if (method.toUpperCase() === 'GET') {
            delete fetchParams.body;
        }

        return new Promise(async (resolve, reject) => {
            fetch(url, fetchParams).then(async (resp) => {
                if (!resp.ok) {
                    // if we get rejected due to 401 unauthorised then, should we force log-out the user?
                    if (resp.status === 401) {
                    }

                    let json = null;
                    try {
                        json = await resp.json();
                    }
                    catch ( err ) {
                        console.log(err);
                        // fall-through
                    }

                    reject(new ApiError(json?.error ?? 'An unknown error occurred', json?.formErrors ?? []));
                }
                else {
                    resolve(resp.json());
                }
            }).catch((error) => {
                reject(new ApiError(error.message));
            });
        });
    }

    static post(endpoint, body = {}, additionalHeaders = { accept: 'application/json' }) {
        let content = body;

        if (body instanceof Object && !(body instanceof FormData)) {
            content = new FormData();

            for (let key in body) {
                // default null values to empty strings, as formdata values are cast as strings before being sent
                content.set(key, body[key] ?? '');
            }
        }

        if (content instanceof FormData) {
            content.set(window.csrfTokenName, window.csrfTokenValue);
        }

        return this.apiFetch('POST', endpoint, content, additionalHeaders);
    }

    static get(endpoint, params = {}, additionalHeaders = {}) {
        let url = endpoint;
        const queryString = (new URLSearchParams(params)).toString();

        if (queryString.length) {
            url = `${url}?${queryString}`;
        }

        return this.apiFetch('GET', url, additionalHeaders);
    }

    static async fbConvertPixelEvent(formData) {
        return new Promise((resolve,reject) => {
            if (!window.siteConfig.hasFacebookConversions) {
                reject(new ApiError('Facebook Conversions has not been configured'));

                return;
            }

            const endpoint = `facebook/convert`;

            return this.post(endpoint, formData);
        });
    }
}